import script from "./SiteBot.vue?vue&type=script&lang=js"
export * from "./SiteBot.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__